export const RutasPrivadas = {
    PRIVATE: 'dashboard',
    HOME: 'dashboard/todos_usuarios',
    NUEVOS_USUARIOS: 'nuevos_usuarios',
    TODOS_USUARIOS: 'todos_usuarios',
    EMPRESAS: 'empresas',
    DATOS_USUARIO: 'datos_usuario'
}
